export default {
  family: ["Roboto", "Roboto", "Heuristica"]
};
